// Module Federation eager-consumption fix:
// shared deps (react, react-dom, ...) phải được async-load TRƯỚC khi bootstrap render.
// Dynamic import() trong file này tạo split point cho Webpack defer.
import('./bootstrap');

export {};
